
export class StatusColorDto {
    id!: string;
    color!: string;
    statusLevel!: string;
    valueConfAttrId!: string;
    valueConfPageId!: string;
}

export class StatusColorsDto{
    pageSize!: number;
    totalCount!: number;
    statusColorDtos!: StatusColorDto[];
}
